import React from 'react';
import { PicnicTenerifePage } from './pages/PicnicTenerifePage';
export function App() {
  return <PicnicTenerifePage data-id="element-0" data-mp="35cttnbw1sbfp" />;
}